module.exports = __webpack_public_path__ + "img/proleasing-logo.5daa14a2.svg";